import { useIntl } from 'react-intl';

import { SimpleChart } from '~/components/Shared/Charts/SimpleChart';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Markdown } from '~/eds/src/components/Markdown/Markdown';
import { Text } from '~/eds/src/components/Text/Text';

import { LibraryModelVersion } from '../../types';

interface Props {
  model: LibraryModelVersion;
}

export const ModelSummary = ({ model }: Props) => {
  const intl = useIntl();

  return (
    <Layout spacing={2} justify="space-between">
      {model.sampleOutputs?.text && (
        <Layout flex="2" direction="column">
          <Text variant="body-medium">
            {intl.formatMessage({
              id: 'ModelSummary.sampleOutputs',
              defaultMessage: 'Sample outputs:',
              description: 'Label for sample outputs section',
            })}
          </Text>
          <Markdown text={model.sampleOutputs.text} />
        </Layout>
      )}
      {model.sampleOutputs?.dashboard?.buckets && (
        <Layout flex="3" direction="column">
          <Text variant="body-medium">
            {intl.formatMessage({
              id: 'ModelSummary.dashboardVisual',
              defaultMessage: 'Dashboard visual',
              description: 'Label for dashboard visual section',
            })}
          </Text>
          <SimpleChart
            buckets={model.sampleOutputs.dashboard.buckets}
            type={model.sampleOutputs.dashboard.type}
            width={400}
          />
        </Layout>
      )}
    </Layout>
  );
};
